module.exports = __webpack_public_path__ + "img/ellipsis.f0326278.svg";